import { usePaginationWithComponent } from "hooks/usePaginationWithComponent";
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { getRequest } from "services/api";
// import { LIMIT_DATA_PER_PAGE } from "utils/constants";
import { buildQueryString } from "utils/queryHelpers";

const AgentRankingContext = createContext();

export const AgentRankingProvider = ({ children }) => {
  const [rankings, setRankings] = useState({
    data: [],
    pagination: null,
    error: null,
    loading: false,
  });

  const [filterOptions, setFilterOptions] = useState({
    search: "",
    currentPage: 1,
    totalPages: 1,
    filters: {
      is_active_session: 1,
    },
  });

  const queryString = buildQueryString({
    search: filterOptions.search || "",
    page: filterOptions.currentPage,
    include: "agent,tier,season",
    [`filter[is_active_session]`]: filterOptions.filters.is_active_session,
  });

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      console.log("search", e.target.value);
      setFilterOptions((prevState) => ({
        ...prevState,
        search: e.target.value,
      }));
    }
  };

  const fetchRankings = useCallback(async () => {
    setRankings((prevState) => ({
      ...prevState,
      loading: true,
    }));

    try {
      const response = await getRequest(`/agent-ranking${queryString}`);
      if (response.success) {
        setRankings({
          data: response.data,
          pagination: response.pagination,
          summary: response.summary,
          error: null,
          loading: false,
        });

        setFilterOptions((prev) => ({
          ...prev,
          totalPages: response.pagination.last_page,
        }));
      }
    } catch (error) {
      setRankings({
        data: [],
        pagination: null,
        error: error.message,
        loading: false,
      });
    }
  }, [queryString]);

  useEffect(() => {
    fetchRankings();
  }, [fetchRankings]);

  const handlePageChange = (page) => {
    setFilterOptions((prevState) => ({
      ...prevState,
      currentPage: page,
    }));
  };

  const totalPages = rankings.pagination?.last_page || 1;

  const Pagination = usePaginationWithComponent({
    totalPages: totalPages,
    currentPage: filterOptions.currentPage,
    onPageChange: handlePageChange,
    visiblePages: 5,
  });

  return (
    <AgentRankingContext.Provider
      value={{
        rankings,
        filterOptions,
        handleSearch,
        refetch: fetchRankings,
        Pagination,
      }}
    >
      {children}
    </AgentRankingContext.Provider>
  );
};

export const useAgentRanking = () => {
  const context = useContext(AgentRankingContext);
  if (!context) {
    throw new Error("useAgentRanking must be used within AgentRankingProvider");
  }

  return context;
};
